module.exports = __webpack_public_path__ + "static/img/dsr.ab05653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsr.png
// module id = yhOd
// module chunks = 48